import MarkerType from "../enums/markerType";

const markerConfiguration = {
    viewedPlanMarkers: [],
    viewedSpecMarkers: [],
    viewedCommunitiesMarkers: [],
}

/**
 * Loads the Viewed Markers ids inside the marker configuration object, in order to
 * display the already visited elements.
 */
const loadViewedMarkers = () => {
    const markersFromSession = sessionStorage.markersViewed !== undefined
         ? JSON.parse(sessionStorage.markersViewed) : markerConfiguration;
    markerConfiguration.viewedPlanMarkers = markersFromSession.viewedPlanMarkers;
    markerConfiguration.viewedSpecMarkers = markersFromSession.viewedSpecMarkers;
    markerConfiguration.viewedCommunitiesMarkers = markersFromSession.viewedCommunitiesMarkers;
}

/**
 * Check if the Hosing Development listing is already visited.
 */
export function isHousingDevelopmentViewed(id){ 
    return markerConfiguration.viewedCommunitiesMarkers.indexOf(id) >= 0;
}

/**
 * Check if the spec unit listing is already visited.
 */
export function isSpecViewed(id){ 
    return markerConfiguration.viewedSpecMarkers.indexOf(id) >= 0;
}

/**
 * Check if the plan listing is already visited.
 */
export function isPlanViewed(id){ 
    return markerConfiguration.viewedPlanMarkers.indexOf(id) >= 0;
}

/**
 * Saved the community id clicked in the session storage.
 */
const saveCommunityMarkerViewed = (id) => {
    if(!isHousingDevelopmentViewed(id)){
        markerConfiguration.viewedCommunitiesMarkers.push(id);
    }
}

/**
 * Saved the spec id clicked in the session storage.
 */
const saveSpecMarkerViewed = (id) => {
    if(!isSpecViewed(id)){
        markerConfiguration.viewedSpecMarkers.push(id);
    }
}

/**
 * Saved the plan id clicked in the session storage.
 */
const savePlanMarkerViewed = (id) => {
    if(!isPlanViewed(id)){
        markerConfiguration.viewedPlanMarkers.push(id);
    }
}

loadViewedMarkers();

/**
 * Gets the Marker Element clicked and handles its info to store it in the right configuration array.
 */
export function saveViewedMarker(marker){ 
    if(marker.type === MarkerType.HousingDevelopment.toString()){
        saveCommunityMarkerViewed(marker.id);
    }
    if(marker.type === MarkerType.BuildablePlan.toString()){
        saveCommunityMarkerViewed(marker.id);
    }
    if(marker.type === MarkerType.PlanUnit.toString()){
        savePlanMarkerViewed(marker.id);
    }
    if(marker.type === MarkerType.SpecUnit.toString()){
        saveSpecMarkerViewed(marker.id);
    }
    sessionStorage.setItem("markersViewed", JSON.stringify(markerConfiguration));
}


